<app-loader *ngIf="isDisabled"></app-loader>
<div class="main-container">
    <div class="card">
        <div class="card-header">
            {{this.Filter.IsSubContractor? 'Subcontractor Multi Site-Employee Mapping' :'Multi Site-Employee Mapping'}}
        </div>

        <!-- Header Section -->
        <div class="card-body">
            <form class="g-3" name="FilterForm" (ngSubmit)="FilterValidate(FilterForm,true)" #FilterForm="ngForm">
                <div class="row">
                    <div class="col-md-6">
                        <label for="BranchID" class="text-label-dark">Branch<span
                                class="mandatory-field">*</span></label>
                        <ng-select name="BranchID" placeholder="Select Branch" [items]="Branchs" bindLabel="BranchName"
                            bindValue="BranchMasterID" [(ngModel)]="this.Filter.BranchID" (change)="ComboLoad('Client')"
                            [selectOnTab]="true" required [disabled]="IsReset">
                        </ng-select>
                        <div class="invalid-feedback">
                            Please select branch!
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label for="ClientID" class="text-label-dark">Client<span
                                class="mandatory-field">*</span></label>
                        <ng-select name="ClientID" placeholder="Select Client" [items]="Clients"
                            bindLabel="ClientGroupName" bindValue="ClientGroupMasterID"
                            [(ngModel)]="this.Filter.ClientID" (change)="ComboLoad('Site')" [selectOnTab]="true"
                            required [disabled]="IsReset">
                        </ng-select>
                        <div class="invalid-feedback">
                            Please select client!
                        </div>
                    </div>
                    <div class="col-md">
                        <label for="SiteID" class="text-label-dark">Site<span class="mandatory-field">*</span></label>
                        <ng-select name="SiteID" placeholder="Select Site" [items]="Sites" bindLabel="SiteName"
                            bindValue="SiteMasterID" [(ngModel)]="this.Filter.SiteID"
                            (change)="ComboLoad('Designation')" [selectOnTab]="true" required [disabled]="IsReset">
                        </ng-select>
                        <div class="invalid-feedback">
                            Please select site!
                        </div>
                    </div>
                    <div class="col-md-auto my-4">
                        <button class="btn btn-primary" [disabled]="IsReset" *ngIf="!IsReset">
                            <i class="bi bi-search me-1" *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            Search
                        </button>
                        <button type="button" class="btn btn-outline-danger" [disabled]="!IsReset" *ngIf="IsReset"
                            (click)="Reset()">
                            <i class="bi bi-x me-1" *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            Reset
                        </button>
                    </div>
                </div>
                <div class="row" *ngIf="this.common.PageRight.IsAdd">
                    <div class="col"></div>
                    <div class="col-auto">
                        <button type="button" (click)="FilterValidate(FilterForm,false)" class="btn btn-primary"
                            [disabled]="!IsReset">
                            <i class="bi bi-plus-circle me-1" *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span> Add
                        </button>
                    </div>
                </div>
            </form>
        </div>

        <!-- Search and Actions Section -->
        <!-- <div class="search-section">
            <div class="d-flex flex-wrap justify-content-between align-items-center gap-3">
                <div class="d-flex gap-2 align-items-center">
                    <div class="input-group" style="width: 300px;">
                        <input type="text" class="form-control" placeholder="Search employees...">
                        <button class="btn btn-outline-primary" type="button">
                            <i class="bi bi-search"></i>
                        </button>
                    </div>
                    <button class="btn btn-primary">
                        <i class="bi bi-plus-circle me-1"></i> Add
                    </button>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="selectAll">
                    <label class="form-check-label" for="selectAll">
                        Select All
                    </label>
                </div>
            </div>
        </div> -->

        <!-- Table Section -->
        <div class="table-container">
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" id="employeedata"
                class="customeDatatable table table-bordered" name="employeedata">
            </table>
        </div>

        <!-- Action Section -->
        <div class="card-footer" *ngIf="this.common.PageRight.IsEdit">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button" class="btn btn-primary" [disabled]="isDisabled || !IsReset"
                    (click)="ESS_EmployeeSiteMapping_InsertUpdate()">
                    <i class="bi bi-chevron-right" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Update':'Loading...'}}</button>
            </div>
        </div>
    </div>
</div>